import { HttpHeaders } from "@angular/common/http";

const headers = new HttpHeaders({
  'Accept': 'application/json',
  'Content-Type': 'application/json; charset=utf-8'
});

const httpOptions = { headers, withCredentials: true };

export { httpOptions };
